import { todayKST } from '../../../utils/date';

export const pad2 = (value) => String(value).padStart(2, '0');

export function previousMonthValue() {
  const [yearText, monthText] = todayKST().split('-');
  const year = Number(yearText);
  const month = Number(monthText);
  if (month === 1) return `${year - 1}-12`;
  return `${year}-${pad2(month - 1)}`;
}

export function parseMonthValue(value) {
  const [year, month] = String(value || '').split('-').map(Number);
  return { year, month };
}

export function nextMonthFirstFromValue(value) {
  const { year, month } = parseMonthValue(value);
  if (!Number.isFinite(year) || !Number.isFinite(month)) return '';
  const nextYear = month === 12 ? year + 1 : year;
  const nextMonth = month === 12 ? 1 : month + 1;
  return `${nextYear}-${pad2(nextMonth)}-01`;
}

export function fmtMoney(value) {
  const numberValue = Number(value || 0);
  const sign = numberValue < 0 ? '-' : '';
  return `${sign}${Math.abs(Math.round(numberValue)).toLocaleString('ko-KR')}원`;
}

export function fmtNum(value) {
  const numberValue = Number(value || 0);
  return Number.isInteger(numberValue)
    ? numberValue.toLocaleString('ko-KR')
    : numberValue.toLocaleString('ko-KR', { maximumFractionDigits: 2 });
}

export function fmtDateRange(start, end) {
  if (!start && !end) return '-';
  if (start === end) return start || '-';
  return `${start || '-'} ~ ${end || '-'}`;
}
